import Requester from "./Requester";

interface CreateDTO {
    name: number
}

const URL = 'api/brands';

export function getBrands(limit: number = 10, page: number = 1, search: string | null = null, options) {
    const requester = new Requester();

    return requester.get(requester.getUrl(URL, [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]), {
        signal: options.signal
    })
}

export function getBrand(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`${URL}/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`${URL}/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(URL), values)
}

export default {
    create,
    getBrands,
    getBrand,
    destroy,
}